import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's110g-s110m01',
    templateUrl: './s110g-s110m01.component.html'
})
export class S110gS110m01Component extends Overlay {
    dfh0001: any = {};
    dfh0002: any = {};
    dfh0003: any = {};
    dfh0004: any = {};
    dfh0005: any = {};
    dfh0006: any = {};
    dfh0007: any = {};
    dfh0008: any = {};
    dfh0009: any = {};
    dfh0010: any = {};
    dfh0011: any = {};
    dfh0012: any = {};
    dfh0013: any = {};
    dfh0014: any = {};
    dfh0015: any = {};
    dfh0016: any = {};
    dfh0017: any = {};
    dfh0018: any = {};
    dfh0019: any = {};
    dfh0020: any = {};
    dfh0021: any = {};
    dfh0022: any = {};
    dfh0023: any = {};
    dfh0024: any = {};
    dfh0025: any = {};
    dfh0026: any = {};
    dfh0027: any = {};
    dfh0028: any = {};
    dfh0029: any = {};
    dfh0030: any = {};
    dfh0031: any = {};
    dfh0032: any = {};
    dfh0033: any = {};
    dfh0034: any = {};
    dfh0035: any = {};
    dfh0036: any = {};
    dfh0037: any = {};
    dfh0038: any = {};
    dfh0039: any = {};
    dfh0040: any = {};
    dfh0041: any = {};
    dfh0042: any = {};
    dfh0043: any = {};
    dfh0044: any = {};
    dfh0045: any = {};
    dfh0046: any = {};
    dfh0047: any = {};
    dfh0048: any = {};
    dfh0049: any = {};
    dfh0050: any = {};
    dfh0051: any = {};
    dfh0052: any = {};
    dfh0053: any = {};
    dfh0054: any = {};
    dfh0055: any = {};
    dfh0056: any = {};
    dfh0057: any = {};
    dfh0058: any = {};
    dfh0059: any = {};
    dfh0060: any = {};
    dfh0061: any = {};
    dfh0062: any = {};
    dfh0063: any = {};
    dfh0064: any = {};
    dfh0065: any = {};
    dfh0066: any = {};
    dfh0067: any = {};
    dfh0068: any = {};
    dfh0069: any = {};
    dfh0070: any = {};
    dfh0071: any = {};
    dfh0072: any = {};
    dfh0073: any = {};
    dfh0074: any = {};
    dfh0075: any = {};
    dfh0076: any = {};
    dfh0077: any = {};
    dfh0078: any = {};
    dfh0079: any = {};
    dfh0080: any = {};
    dfh0081: any = {};
    dfh0082: any = {};
    dfh0083: any = {};
    dfh0084: any = {};
    dfh0085: any = {};
    dfh0086: any = {};
    dfh0087: any = {};
    dfh0088: any = {};
    dfh0089: any = {};
    dfh0090: any = {};
    dfh0091: any = {};
    dfh0092: any = {};
    dfh0093: any = {};
    dfh0094: any = {};
    dfh0095: any = {};
    dfh0096: any = {};
    dfh0097: any = {};
    dfh0098: any = {};
    dfh0099: any = {};
    dfh0100: any = {};
    dfh0101: any = {};
    dfh0102: any = {};
    dfh0103: any = {};
    dfh0104: any = {};
    dfh0105: any = {};
    dfh0106: any = {};
    dfh0107: any = {};
    dfh0108: any = {};
    dfh0109: any = {};
    dfh0110: any = {};
    dfh0111: any = {};
    dfh0112: any = {};
    dfh0113: any = {};

    public FIELDS: string[] = ['dfh0001', 'dfh0002', 'dfh0003', 'dfh0004', 'dfh0005', 'dfh0006', 'dfh0007', 'dfh0008', 'dfh0009', 'dfh0010', 'dfh0011', 'dfh0012', 'dfh0013', 'dfh0014', 'dfh0015', 'dfh0016', 'dfh0017', 'dfh0018', 'dfh0019', 'dfh0020', 'dfh0021', 'dfh0022', 'dfh0023', 'dfh0024', 'dfh0025', 'dfh0026', 'dfh0027', 'dfh0028', 'dfh0029', 'dfh0030', 'dfh0031', 'dfh0032', 'dfh0033', 'dfh0034', 'dfh0035', 'dfh0036', 'dfh0037', 'dfh0038', 'dfh0039', 'dfh0040', 'dfh0041', 'dfh0042', 'dfh0043', 'dfh0044', 'dfh0045', 'dfh0046', 'dfh0047', 'dfh0048', 'dfh0049', 'dfh0050', 'dfh0051', 'dfh0052', 'dfh0053', 'dfh0054', 'dfh0055', 'dfh0056', 'dfh0057', 'dfh0058', 'dfh0059', 'dfh0060', 'dfh0061', 'dfh0062', 'dfh0063', 'dfh0064', 'dfh0065', 'dfh0066', 'dfh0067', 'dfh0068', 'dfh0069', 'dfh0070', 'dfh0071', 'dfh0072', 'dfh0073', 'dfh0074', 'dfh0075', 'dfh0076', 'dfh0077', 'dfh0078', 'dfh0079', 'dfh0080', 'dfh0081', 'dfh0082', 'dfh0083', 'dfh0084', 'dfh0085', 'dfh0086', 'dfh0087', 'dfh0088', 'dfh0089', 'dfh0090', 'dfh0091', 'dfh0092', 'dfh0093', 'dfh0094', 'dfh0095', 'dfh0096', 'dfh0097', 'dfh0098', 'dfh0099', 'dfh0100', 'dfh0101', 'dfh0102', 'dfh0103', 'dfh0104', 'dfh0105', 'dfh0106', 'dfh0107', 'dfh0108', 'dfh0109', 'dfh0110', 'dfh0111', 'dfh0112', 'dfh0113'];
    public LINES: number[] = [1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12, 14, 15, 16, 17, 18, 19, 20, 22, 23, 24];

    ngAfterViewInit(): void {
    }
}
